const ABSOLUTE_RE = /^(\d{2})\/(\d{2})\/(\d{2}) (\d{2}):(\d{2}):(\d{2})$/;
const ISO_RE = /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):(\d{2}))?/;
const DMY_RE = /^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/;

const pad2 = (n: number) => String(n).padStart(2, '0');

const toAbsolute = (date: Date): string => {
  const yy = pad2(date.getFullYear() % 100);
  const mm = pad2(date.getMonth() + 1);
  const dd = pad2(date.getDate());
  const hh = pad2(date.getHours());
  const mi = pad2(date.getMinutes());
  const ss = pad2(date.getSeconds());
  return `${yy}/${mm}/${dd} ${hh}:${mi}:${ss}`;
};

export const parseLastExecutionTimestamp = (text: string): number => {
  if (!text) return 0;
  const absolute = text.trim().match(ABSOLUTE_RE);
  if (absolute) {
    const [, yy, mm, dd, hh, mi, ss] = absolute;
    const year = 2000 + Number(yy);
    const dt = new Date(
      year,
      Number(mm) - 1,
      Number(dd),
      Number(hh),
      Number(mi),
      Number(ss)
    );
    return Number.isNaN(dt.getTime()) ? 0 : dt.getTime();
  }
  return 0;
};

export const pickMostRecentLastExecution = (texts: string[]): string => {
  if (!texts.length) return '-';
  const parsed = texts.map((text) => ({
    text,
    ts: parseLastExecutionTimestamp(text),
  }));
  parsed.sort((a, b) => b.ts - a.ts);
  return parsed[0]?.text || '-';
};

export const formatAbsoluteLastExecution = (raw?: string | null): string => {
  if (raw == null || raw === '' || raw === '—') return '—';
  const s = String(raw).trim();

  if (ABSOLUTE_RE.test(s)) return s;

  const iso = s.match(ISO_RE);
  if (iso) {
    const dt = new Date(
      Number(iso[1]),
      Number(iso[2]) - 1,
      Number(iso[3]),
      Number(iso[4] ?? 0),
      Number(iso[5] ?? 0),
      Number(iso[6] ?? 0)
    );
    return Number.isNaN(dt.getTime()) ? s : toAbsolute(dt);
  }

  const dmy = s.match(DMY_RE);
  if (dmy) {
    const dt = new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
    return Number.isNaN(dt.getTime()) ? s : toAbsolute(dt);
  }

  return s;
};
